module.exports = __webpack_public_path__ + "img/electricCar-orange.abc32bd6.svg";